const getters = {
  sidebar: (state) => state.app.sidebar,
  language: (state) => state.app.language,
  device: (state) => state.app.device,
  company: (state) => state.app.company,
  portal: (state) => state.app.portal,
  routes: (state) => state.app.routes,
  settings: (state) => state.app.settings,

  portalBucket: (state) => state.app.settings.portalBucket,
  classificationOptions: (state) => state.classification.options,
  enabledClassificationOptions: (state) => state.classification.enabledOptions,
  classificationFieldLabels: (state) => state.classification.fieldLabels,
};
export default getters;
